import { assertOK } from "../error";
import { API_BASE } from "./endpoint";

export interface Organization {
  organizationId: number;
  name: string;
  registeredAt: number;
}

export interface Organization {
  organizationId: number;
  name: string;
}

export interface Membership {
  personId: number;
  organizationId: number;
  joinedAt: number;
  organization: Organization;
}

export interface PersonalData {
  dialingCode: string;
  cellPhone: string;
  email: string;
  firstName: string;
  lastName: string;
  nationalId?: string;
  memberships?: Membership[];
}

export interface Person extends PersonalData {
  personId: number;
  registeredAt: number;
}

interface CheckResult {
  exists: boolean;
}

export async function registerPerson(
  personalData: PersonalData
): Promise<Person | null> {
  const res = await fetch(`${API_BASE}/person`, {
    method: "POST",
    body: JSON.stringify(personalData),
    headers: { "Content-Type": "application/json" },
  });

  assertOK(res);

  return (await res.json()) as Person;
}

export async function updatePerson(
  personalData: PersonalData
): Promise<Person | null> {
  const res = await fetch(`${API_BASE}/person`, {
    method: "PUT",
    body: JSON.stringify(personalData),
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  });

  assertOK(res);

  return (await res.json()) as Person;
}

export async function getCurrentUser(): Promise<Person | null> {
  const res = await fetch(`${API_BASE}/person`, {
    method: "GET",
    credentials: "include",
  });

  if (!res.ok) {
    return null;
  }

  return res.json();
}

export async function checkEmail(email: string): Promise<boolean> {
  const res = await fetch(`${API_BASE}/person/check/email`, {
    method: "POST",
    body: JSON.stringify({ email }),
    headers: { "Content-Type": "application/json" },
  });

  assertOK(res);

  const result = (await res.json()) as CheckResult;

  return result.exists;
}

export async function checkPhoneNumber(
  dialingCode: string,
  cellPhone: string
): Promise<boolean | null> {
  const res = await fetch(`${API_BASE}/person/check/phone-number`, {
    method: "POST",
    body: JSON.stringify({ dialingCode, cellPhone }),
    headers: { "Content-Type": "application/json" },
  });

  assertOK(res);

  const result = (await res.json()) as CheckResult;

  return result.exists;
}
